export enum QueryKeys {
  knowledgeFolders = 'knowledgeFolders',
  knowledgeList = 'knowledgeList',
  knowledgeDetail = 'knowledgeDetail',
  knowledgeEvent = 'knowledgeEvent',
  resourceKnowledgeList = 'resourceKnowledgeList',
  createSession = 'createSession',
  trackPatent = 'trackPatent',
  trackIDPatent = 'trackIDPatent',
  getPatentById = 'getPatentById',
  getRelevancyByPatent = 'getRelevancyByPatent',
  getPriorArtRelevancyByPatent = 'getPriorArtRelevancyByPatent',
  getPDF = 'getPDF',
  getFigures = 'getFigures',
  exportPatents = 'exportPatents',
  exportInventionDisclosurePatents = 'exportInventionDisclosurePatents',
  infringementDetectionCreate = 'infringementDetectionCreate',
  infringementDetectionDuplicate = 'infringementDetectionDuplicate',
  infringementDetectionSetName = 'infringementDetectionSetName',
  infringementDetectionSetProductDescription = 'infringementDetectionSetProductDescription',
  infringementDetectionSetImage = 'infringementDetectionSetImage',
  infringementDetectionDeleteImage = 'infringementDetectionDeleteImage',
  infringementDetectionGetFilters = 'infringementDetectionGetFilters',
  infringementDetectionSetFilters = 'infringementDetectionSetFilters',
  publishInfringementDetectionById = 'publishInfringementDetectionById',
  deleteInfringementDetectionById = 'deleteInfringementDetectionById',
  infringementDetectionSendFeedback = 'infringementDetectionSendFeedback',
  infringementDetectionUpdateScore = 'infringementDetectionUpdateScore',
  infringementDetectionGetUpdatedScore = 'infringementDetectionGetUpdatedScore',
  getCompoundAutocomplete = 'getCompoundAutocomplete',
  getInfringementDetectionById = 'getInfringementDetectionById',
  getInfringementDetectionStatus = 'getInfringementDetectionStatus',
  getAllInfringementDetection = 'getAllInfringementDetection',
  getInfringementDetectionFeatureOverlap = 'getInfringementDetectionFeatureOverlap',
  getInfringementDetectionFeatureTree = 'getInfringementDetectionFeatureTree',
  getSharedUsers = 'getSharedUsers',
  getInventionDisclosureFilters = 'getInventionDisclosureFilters',
  getAllFTO = 'getAllFTO',
  publishFTOById = 'publishFTOById',
  getFTOById = 'getFTOById',
  putFTOName = 'putFTOName',
  putFTOImage = 'putFTOImage',
  deleteFTOImage = 'deleteFTOImage',
  getFTOFeatureTree = 'getFTOFeatureTree',
  getFTORunFeatureTree = 'getFTORunFeatureTree',
  putFTOFeatureTree = 'putFTOFeatureTree',
  getFTOPatents = 'getFTOPatents',
  getFTOResults = 'getFTOResults',
  getFTOStatus = 'getFTOStatus',
  FTOCreateDuplicate = 'FTOCreateDuplicate',
  sendFTOFeedback = 'sendFTOFeedback',
  getFTOFeatureOverlap = 'getFTOFeatureOverlap',
  FTOUpdateScore = 'FTOUpdateScore',
  getUpdatedScoresFTO = 'getUpdatedScoresFTO',
  getPatentReasoning = 'getPatentReasoning',
  fetchNotifications = 'fetchNotifications',
  userSearch = 'userSearch',
  adminUserSearch = 'adminUserSearch',
  adminUserDirectory = 'adminUserDirectory',
  platformResourceCapabilities = 'platformResourceCapabilities',
  developerAdminGetTaskTypes = 'developerAdminGetTaskTypes',
  developerAdminGetTaskTypeStatuses = 'developerAdminGetTaskTypeStatuses',
  developerAdminGetTaskStatus = 'developerAdminGetTaskStatus',
  developerAdminGetUserForTask = 'developerAdminGetUserForTask',
  developerAdminGetProjectForTask = 'developerAdminGetProjectForTask',
  developerAdminGetFileProcessingStatus = 'developerAdminGetFileProcessingStatus',
  developerGetRolesOverview = 'developerGetRolesOverview',
  developerGetPromptFiles = 'developerGetPromptFiles',
  developerGetPromptOverrides = 'developerGetPromptOverrides',
  developerGetBranches = 'developerGetBranches',
  getUserById = 'getUserById',
  getPlatformUserById = 'getPlatformUserById',
  patentIdSearch = 'patentIdSearch',
  getApiDocs = 'getApiDocs',
  FTOSetProductDescription = 'FTOSetProductDescription',
  getReasoningID = 'getReasoningID',
  searchByPatentIDs = 'searchByPatentIDs',
  getHighlightPatentDataByID = 'getHighlightPatentDataByID',
  getCoverImage = 'getCoverImage',
  getAssignedOrganization = 'getAssignedOrganization',
  getPatentNotes = 'getPatentNotes',
  organizationSearch = 'organisationSearch',
  getOrganizationById = 'getOrganizationById',
  getOrganizationSettings = 'getOrganizationSettings',
  getCPCClassifications = 'getCPCClassifications',
  getLiterature = 'getLiterature',
  getNonPatentLiterature = 'getNonPatentLiterature',
  getInfringementDetectionResults = 'getInringementDetectionResults',
  getSubsystemAnalysis = 'getSubsystemAnalysis',
  getSubsystemById = 'getSubsystemById',
  getAccessType = 'getAccessType',
  effectiveAccess = 'effectiveAccess',
  validatePatentIds = 'validatePatentIds',
  getFileById = 'getFileById',
  getFileURL = 'getFileURL',
  getChartImageURL = 'getChartImageURL',
  getFileFigures = 'getFileFigures',
  getStaticFile = 'getStaticFile',
  getWorkflowFiles = 'getWorkflowFiles',
  getFileFolders = 'getFileFolders',
  getFigureCandidateFiles = 'getFigureCandidateFiles',
  searchRegisterFiles = 'searchRegisterFiles',
  previewRegisterFile = 'previewRegisterFile',
  getAskAiConversationHistory = 'getAskAiConversationHistory',
  getCompounds = 'getCompounds',
  getCompoundThumbnail = 'getCompoundThumbnail',
  getCompoundPreview = 'getCompoundPreview',
  getDraftCompounds = 'getDraftCompounds',
  getDraftCompoundById = 'getDraftCompoundById',
  getSequences = 'getSequences',
  getSequenceById = 'getSequenceById',
  getMolTypes = 'getMolTypes',
  getPatentFigures = 'getPatentFigures',
  getRolesV2 = 'getRolesV2',
  getLockResource = 'getLockResource',
  getCustomInstruction = 'getCustomInstruction',
  listCustomInstructions = 'listCustomInstructions',
  getChatMessages = 'getChatMessages',
  getChatActiveTurn = 'getChatActiveTurn',
  getDocumentStyleGuide = 'getDocumentStyleGuide',
  getTemplateStyleGuide = 'getTemplateStyleGuide',
  getDocument = 'getDocument',
  getDocumentsByResource = 'getDocumentsByResource',
  getTemplates = 'getTemplates',
  listTemplates = 'listTemplates',
  getPlatformStatus = 'getPlatformStatus',
  getAdminFeatureFlags = 'getAdminFeatureFlags',
  getUserFeatureFlags = 'getUserFeatureFlags',
  getFeatureFlagOverrides = 'getFeatureFlagOverrides',
  getVersionInfo = 'getVersionInfo',
  getPatentPDFUrl = 'getPatentPDFUrl',
  conferenceList = 'conferenceList',
  getDocx = 'getDocx',
  getEmbeddedCompounds = 'getEmbeddedCompounds',
  getFigureById = 'getFigureById',
  saveFigure = 'saveFigure',
  getReferenceSignsByResource = 'getReferenceSignsByPatentDraft',
  getReferenceSignsByFigure = 'getReferenceSignsByFigure',
  getTemporaryFile = 'getTemporaryFile',
  getDataTable = 'getDataTable',
  getDataTableRows = 'getDataTableRows',
  getDataTableRowsByIds = 'getDataTableRowsByIds',
  getDataTablePatentFieldValues = 'getDataTablePatentFieldValues',
  viewDataTableCharts = 'viewDataTableCharts',
  listDataTables = 'listDataTables',
  getForm = 'getForm',
  listForms = 'listForms',
  saveFormAnswers = 'saveFormAnswers',
  sheetGrid = 'sheetGrid',
  reviewDataTableCells = 'reviewDataTableCells',
  glossarySearchTermDefinitions = 'glossarySearchTermDefinitions',
  glossarySearchRelatedTerms = 'glossarySearchRelatedTerms',
  listProjects = 'listProjects',
  listProjectFacets = 'listProjectFacets',
  projectFolders = 'projectFolders',
  customFieldDefinitions = 'customFieldDefinitions',
  projectAnalytics = 'projectAnalytics',
  listExternalSources = 'listExternalSources',
  listExternalConnections = 'listExternalConnections',
  searchExternalSourceItems = 'searchExternalSourceItems',
  listExternalSourceItems = 'listExternalSourceItems',
  previewExternalSourceFile = 'previewExternalSourceFile',
  listPatentFamilyMembers = 'listPatentFamilyMembers',
  listProjectTasks = 'listProjectTasks',
  uploadFile = 'uploadFile',
  deleteFile = 'deleteFile',
  batchCreateDraftCompounds = 'batchCreateDraftCompounds',
  deleteDraftCompounds = 'deleteDraftCompounds',
  deleteAllDraftCompounds = 'deleteAllDraftCompounds',
  batchCreateSequences = 'batchCreateSequences',
  importSequences = 'importSequences',
  deleteSequences = 'deleteSequences',
  deleteAllSequences = 'deleteAllSequences',
  deleteFolder = 'deleteFolder',
}
